import { render, staticRenderFns } from "./forestComment.vue?vue&type=template&id=48686de2&"
import script from "./forestComment.vue?vue&type=script&lang=js&"
export * from "./forestComment.vue?vue&type=script&lang=js&"
import style0 from "./forestComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports